import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import * as signalR from "@microsoft/signalr";
import { SignalRStates } from "../../types/types.system";
import { HubConnection } from "@microsoft/signalr";


interface ConnectionItem {
    id: string;
    connection: HubConnection;
}

const connections: ConnectionItem[] = [];

// Define the initial state using that type
const initialState: SignalRStates = {
    DataChangeId: null,
    DataChangeIsconnected: false,
    DataSusriptions: [],
    ErrorData: '',
    Notifycations: undefined,
    ErrorNotifications: '',
    NotifycationsSusriptions: []
}


//Encargado de manejar todas las órdenes del sistema y configuración general

export const singlaRSlice = createSlice({
    name: 'signalR',
    initialState,
    reducers: {
        connect: (state, action: PayloadAction<string>) => {
            state.DataChangeId = action.payload;
            state.DataChangeIsconnected = true;
            const connection = getConnectionById(action.payload)
        },
        disconnect: (state) => {
            const connectionId = state.DataChangeId;

            if (connectionId) {
                const index = connections.findIndex((item) => item.id === connectionId);

                if (index !== -1) {
                    connections.splice(index, 1);
                }
            }

            state.DataChangeId = null;
            state.DataChangeIsconnected = false;
        },
        addSuscriptionData: (state, action: PayloadAction<string>) => {
            if (!state.DataSusriptions.includes(action.payload)) {
                state.DataSusriptions.push(action.payload)
            }
        }
    },
})


export const { connect, addSuscriptionData, disconnect } = singlaRSlice.actions;

export function getConnectionById(connectionId: string): HubConnection | null {
    const connectionItem = connections.find((item) => item.id === connectionId);
    return connectionItem ? connectionItem.connection : null;
}

export function addConnection(connectionId: string | null, connection: HubConnection) {
    if (!connectionId) {
        return;
    }
    connections.push({ id: connectionId, connection });
}

export function deleteConnection(connectionId: string | null) {
    if (!connectionId) {
        return;
    }
    const updatedConnections = connections.filter((item) => item.id !== connectionId);
    connections.length = 0; // Vaciar el array original
    Array.prototype.push.apply(connections, updatedConnections); // Asignar los elementos actualizados al array original
}
